'use client';

import type { ReactNode } from 'react';
import {
  Modal as ChakraModal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  type ModalBodyProps,
  ModalContentProps,
} from '@chakra-ui/react';

export const Modal = ({
  children,
  isOpen,
  bodyProps,
  containerProps,
  contentProps,
  footerContent,
  headerContent,
  showCloseButton = true,
  onClose,
}: ModalProps) => {
  return (
    <ChakraModal isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent containerProps={containerProps} {...contentProps}>
        {headerContent && <ModalHeader>{headerContent}</ModalHeader>}
        {showCloseButton && <ModalCloseButton />}
        <ModalBody {...bodyProps}>{children}</ModalBody>
        {footerContent && <ModalFooter>{footerContent}</ModalFooter>}
      </ModalContent>
    </ChakraModal>
  );
};

type ModalProps = {
  children: ReactNode;
  isOpen: boolean;
  bodyProps?: Omit<ModalBodyProps, 'children'>;
  containerProps?: Omit<ModalContentProps['containerProps'], 'children'>;
  contentProps?: Omit<ModalContentProps, 'children'>;
  footerContent?: ReactNode;
  headerContent?: ReactNode;
  showCloseButton?: boolean;
  onClose: () => void;
};
